import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export async function polishText({ text, kind = "bullet", role = "" }) {
  const res = await axios.post(`${API}/polish`, { text, kind, role });
  return res.data.polished;
}

export async function parseResumeFile(file) {
  const form = new FormData();
  form.append("file", file);
  const res = await axios.post(`${API}/parse-resume`, form, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 95000,
  });
  return normalizeParsedResume(res.data.resume);
}

// Ensure every array-item in a parsed résumé has a stable `id`. The backend
// parser returns arrays without IDs; without this the section forms would use
// `key={undefined}` and React reconciliation would break.
function normalizeParsedResume(resume) {
  if (!resume || typeof resume !== "object") return resume;
  const withIds = (arr) =>
    Array.isArray(arr) ? arr.map((it) => ({ ...it, id: it?.id || crypto.randomUUID() })) : arr;
  return {
    ...resume,
    experience: withIds(resume.experience),
    education: withIds(resume.education),
    projects: withIds(resume.projects),
    certifications: withIds(resume.certifications),
    languages: withIds(resume.languages),
  };
}

export async function tailorResume({ resume, jd }) {
  const res = await axios.post(`${API}/tailor`, { resume, jd }, { timeout: 95000 });
  return {
    ...res.data,
    resume: normalizeParsedResume(res.data.resume),
  };
}
